import { render } from "./index.vue?vue&type=template&id=5392830c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5392830c&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=5392830c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5392830c"]])

export default __exports__